export const api = {
  GET_LIST_APPROVAL_REFUND: '/index.php?r=api/v1/refund_internal/refund/list-approval-request-refund',
  SEND_REJECT_REFUND: '/index.php?r=api/v1/refund_internal/refund/reject',
  SEND_APPROVE_REFUND: '/index.php?r=api/v1/refund_internal/refund/approve',
  GET_DETAIL_REQUEST_REFUND: '/index.php?r=api/v1/refund_internal/refund/detail-request-refund',
};


export const failedReject = (ctx, response) => {
  ctx.commit('setProgressTitle', 'Reject Failed');
  ctx.commit('setProgressColor', 'red');
  ctx.commit('setPercentage', 0);
  ctx.commit('setFailedResponse', true);

  const errorMessages = response?.data?.error_message;
  const errorMessageText = Array.isArray(errorMessages)
    ? errorMessages.join(', ')
    : 'Request failed, please check history or transaction report!';
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: errorMessageText,
      icon: 'mdi-alert',
      color: 'red',
    },
    { root: true }
  );
  ctx.commit('setLoading', false);
  return false; 
};

export const failedApprove = (ctx, response) => {
  ctx.commit('setProgressTitle', 'Approval Failed');
  ctx.commit('setProgressColor', 'red');
  ctx.commit('setPercentage', 0);
  ctx.commit('setFailedResponse', true);

  const errorMessages = response?.data?.error_message;
  const errorMessageText = Array.isArray(errorMessages)
    ? errorMessages.join(', ')
    : 'Request failed, please check history or transaction report!';
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: errorMessageText,
      icon: 'mdi-alert',
      color: 'red',
    },
    { root: true }
  );
  ctx.commit('setStateVariable', {
    payload: false,
    variable: 'refundStatus',
  });
};

export const successApprove = (ctx, responseData) => {
  ctx.commit('setPercentage', 100);
  ctx.commit('setProgressTitle', 'Approval Complete');
  ctx.commit('setApprovedStatus', {
    payload: 'success',
  });
  
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: responseData?.message_id || 'Approve Successfully !',
      icon: 'mdi-check',
      color: 'green',
    },
    { root: true }
  );

  ctx.commit('setRefundData', responseData.data || {});
  ctx.commit('setLoading', false);
};

export const successReject = (ctx, responseData) => {
  ctx.commit('setPercentage', 100);
  ctx.commit('setProgressTitle', 'Reject Complete');
  ctx.commit('setApprovedStatus', {
    payload: 'success',
  });
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: responseData?.message_id || 'Reject Successfully !',
      icon: 'mdi-check',
      color: 'green',
    },
    { root: true }
  );

  ctx.commit('setRefundData', responseData.data || {});
  ctx.commit('setLoading', false);

};
